import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BarcodeOutlined,
  UserSwitchOutlined,
  DollarOutlined,
  OrderedListOutlined,
  EnvironmentOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  // [HIDDEN] VIP Rewards / Loyalty Cards — temporarily hidden, do not delete
  // CrownOutlined
} from '@ant-design/icons';

interface SideMenuProps {
  siderCollapsed: boolean;
  collapseToggle: (collapsed: boolean) => void;
}

const menuItems = [
  { key: '/merchants',        icon: <UserSwitchOutlined />,  label: 'Merchants' },
  { key: '/orders',           icon: <OrderedListOutlined />, label: 'Orders' },
  { key: '/merchant_payables',icon: <DollarOutlined />,      label: 'Merchant Payables' },
  { key: '/delivery_payables',icon: <DollarOutlined />,      label: 'Delivery Payables' },
  { key: '/locations',        icon: <EnvironmentOutlined />, label: 'Locations' },
  { key: '/sales_reports',    icon: <BarChartOutlined />,    label: 'Sales Reports' },
  { key: '/categories',       icon: <AppstoreOutlined />,    label: 'Categories' },
  { key: '/vouchers',         icon: <BarcodeOutlined />,     label: 'Vouchers' },
  // [HIDDEN] VIP Rewards / Loyalty Cards — temporarily hidden, do not delete
  // { key: '/loyalty-settings', icon: <CrownOutlined />,       label: 'Loyalty' },
];

const SideMenuView = ({ siderCollapsed, collapseToggle }: SideMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();  // ✅ replaces props.location

  const toggleSidebar = () => {
    collapseToggle(!siderCollapsed);
  };

  return (
    <div className="sidebar">
      <div className="sideToggle">
        <div onClick={toggleSidebar} className="toggle-icon">
          {siderCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
      </div>

      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}   // ✅ controlled — stays in sync with URL
        items={menuItems.map(({ key, icon, label }) => ({
          key,
          icon,
          label,
          onClick: () => navigate(key),       // ✅ replaces props.history.push
        }))}
      />
    </div>
  );
};

export default SideMenuView;